import {
    BarChart3,
    BookOpen,
    ChartNoAxesCombined,
    Gamepad2,
    Home,
    Import,
    type LucideIcon,
    Settings,
} from "lucide-react";

export const PAGE = {
    Overview: "OVERVIEW",
    Games: "GAMES",
    Stats: "STATS",
    Analyze: "ANALYZE",
    Import: "IMPORT",
    Study: "STUDY",
    Settings: "SETTINGS",
} as const;

export type Page = (typeof PAGE)[keyof typeof PAGE];

type PageSummary = {
    page: Page;
    title: string;
    url: string;
    icon: LucideIcon;
};

export const PAGE_SUMMARIES: Record<Page, PageSummary> = {
    OVERVIEW: {
        page: PAGE.Overview,
        title: "Overview",
        url: "/overview",
        icon: Home,
    },
    GAMES: {
        page: PAGE.Games,
        title: "Games",
        url: "/games",
        icon: Gamepad2,
    },
    ANALYZE: {
        page: PAGE.Analyze,
        title: "Analyze",
        url: "/analyze",
        icon: ChartNoAxesCombined,
    },
    STATS: {
        page: PAGE.Stats,
        title: "Stats",
        url: "/stats",
        icon: BarChart3,
    },
    IMPORT: {
        page: PAGE.Import,
        title: "Import",
        url: "/import",
        icon: Import,
    },
    STUDY: {
        page: PAGE.Study,
        title: "Study",
        url: "/study",
        icon: BookOpen,
    },
    SETTINGS: {
        page: PAGE.Settings,
        title: "Settings",
        url: "/settings",
        icon: Settings,
    },
};

export const getPageSummary = (page: Page): PageSummary => PAGE_SUMMARIES[page];

const order: Page[] = [
    PAGE.Overview,
    PAGE.Games,
    PAGE.Stats,
    // PAGE.Analyze,
    PAGE.Import,
    // PAGE.Study,
    // PAGE.Settings,
];

export const pagesInOrder = order.map((page) => PAGE_SUMMARIES[page]);
